import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=046db8af&scoped=true"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoveryPassword.vue?vue&type=style&index=0&id=046db8af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046db8af",
  null
  
)

export default component.exports